import { Card, CardContent, createStyles, makeStyles } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDialogHandle } from "../../actions/dialog";
import { IReduxAppState } from "../../reducers";
import { VenueSelectionDialog } from "../modal/VenueSelectionDialog";
import { VenueTitle } from "./VenueTitle";

import { outstandingSwitch } from "../../actions/outstanding";
import { IYoelloTheme } from "../../yoello-lib/modules/themes/IYoelloTheme";
import { Skeleton } from "@material-ui/lab";
import useTask from "../../hooks/useTask";
import { useStyles } from "../../components/Outstanding"
import { useHistory } from "react-router-dom";


const useStyles2 = makeStyles((theme: IYoelloTheme) => createStyles({
    root: {
        padding: '1rem 2rem',
        margin: 0

    },
    card: {
        borderRadius: "10px",
    },
    content: {
        flex: '1 0 auto',
        // padding: '1rem 2rem !important',
        transition: "0.24s ease-in-out",
        // minHeight: '5rem',
        // maxHeight: '9.5rem',
        "&:hover": {
            background: 'rgba(0, 0, 0, 0.04)',
            cursor: 'pointer'
        },
        paddingBottom: "16px !important"
    },
    icon: {
        // marginTop: '0.85rem',
        color: '#757575',
        float: 'right'
    },
    manageVenues: {
        color: theme.palette.text.secondary,
        borderTop: `1px ${theme.custom.color.bgGreyMid} solid`,
        fontSize: "0.9rem",
        marginTop: '0.5rem',
        paddingTop: '0.5rem'
    },
    titleContainer: {
        paddingLeft: '0.25rem',
    },
    oustandingText: {
        margin: "0 1rem",
        letterSpacing: '0.25rem',
        "@media only screen and (max-width: 768px)": {
            marginLeft: "3.5rem"
        },
    },
    totalText: {
        color: '#C4C4C4',
    },
    modalContainer: {
        "& .MuiDialog-paperWidthMd": {
            width: "44rem!important",
        },
    }
}));

interface IVenueCardProps {
    isLoading?: boolean;
}

export function VenueCard({
    isLoading = false
}: IVenueCardProps) {
    const classes = useStyles();
    const classNames = useStyles2();
    const seletectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const Venue = useSelector((state: IReduxAppState) => state.venue[seletectedVenueId]?.venueData);
    const Location = useSelector((state: IReduxAppState) => state.venue[seletectedVenueId]?.venueLocation);
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { doneTasks, totalTasks, isTasksLoading } = useTask();

    function openYourVenueDialog() {
        if (isLoading) {
            return;
        }
            dispatch(
                setDialogHandle({
                    Component: VenueSelectionDialog,
                    ComponentProps: {
                        history
                    },
                    dialogTitle: t("venueSelection.title"),
                    isFormDialog: false,
                    styles: { className: classNames.modalContainer }
                })
            );

    }

    const renderOutstanding = () => {
        return (isLoading || isTasksLoading)? <Skeleton height={60} style={{background:"#212121",
        borderRadius: "0.625rem"}}/> :
         totalTasks > 0 && doneTasks < totalTasks ? <div className={classes.outstanding}>
            <div className="header" onClick={(e) => {
                e.stopPropagation();
                dispatch(outstandingSwitch(true));
            }}>
                {t("outstanding.title")}
                <span className={classNames.oustandingText}>
                    {doneTasks}
                    <span className={classNames.totalText}>
                        /{totalTasks}
                    </span>
                </span>
            </div>
        </div> : null;
    };

    return (
        <div data-component-name="VenueCard" className={classNames.root}>
            <Card variant="outlined" className={classNames.card}>
                <CardContent className={classNames.content} onClick={openYourVenueDialog}>
                    <div className={classNames.titleContainer}>
                        <VenueTitle location={Location!} venue={Venue!} isLoading={isLoading} />
                    </div>
                    {renderOutstanding()}
                    <div className={classNames.manageVenues}>
                        {isLoading ? <Skeleton variant="text" width={"60%"} height={25} animation="wave" />
                            :
                            <span className={classNames.titleContainer}>
                                {t('venueSelection.manageVenues')} <ChevronRight className={classNames.icon} />
                            </span>
                        }
                    </div>
                </CardContent>

            </Card>
        </div >

    );
}